import { apiRequest } from '../../../helpers/apiRequest/apiRequest';
import { LOGOUT_URL } from '../../../constants/ROUTECONSTANTS';
import { rollbar, logErrorFromPromise } from '../../../components/RollbarConfig/RollbarConfig';
import { NOTIFICATION_TYPE, SOMETHING_WENT_WRONG } from '../../../constants/CONSTANTS';

/**
 * To get user details
 * @param {context} notificationContext
 * @param {context} loaderContext
 * @returns {Promise<object>}
 */
export const getUserInfo = (notificationContext, loaderContext) => {
  loaderContext.enableLoader(true);
  const url = `${process.env.REACT_APP_IDAM_API_URL}connect/userinfo`;
  return apiRequest('GET', url).then((response) => {
    loaderContext.enableLoader(false);
    if (response && response.status === 401) {
      localStorage.clear();
      window.location.href = LOGOUT_URL;
    }
    if (response && response.status === 400) {
      notificationContext.setNotificationState({
        type: NOTIFICATION_TYPE.ATTENTION,
        title: SOMETHING_WENT_WRONG,
        message: ''
      });
      logErrorFromPromise(response.json());
    }
    return response.json();
  })
    .catch((response) => {
      loaderContext.enableLoader(false);
      notificationContext.setNotificationState({
        type: NOTIFICATION_TYPE.ATTENTION,
        title: SOMETHING_WENT_WRONG,
        message: ''
      });
      rollbar.error(response);
    });
};

/**
 * To get student details
 * @param {string} studentId
 * @param {context} notificationContext
 * @param {context} loaderContext
 * @returns {Promise<object>}
 */
export const getStudentInfo = (studentId, notificationContext, loaderContext) => {
  loaderContext.enableLoader(true);
  const url = `${process.env.REACT_APP_IDAM_API_URL}userProfile/${studentId}/student`;
  return apiRequest('GET', url).then((response) => {
    loaderContext.enableLoader(false);
    if (response && response.status === 401) {
      localStorage.clear();
      window.location.href = LOGOUT_URL;
    }
    if (response && response.status === 400) {
      notificationContext.setNotificationState({
        type: NOTIFICATION_TYPE.ATTENTION,
        title: SOMETHING_WENT_WRONG,
        message: ''
      });
    }
    return response.json();
  })
    .catch(() => {
      loaderContext.enableLoader(false);
      notificationContext.setNotificationState({
        type: NOTIFICATION_TYPE.ATTENTION,
        title: SOMETHING_WENT_WRONG,
        message: ''
      });
    });
};
